import { z } from "zod";

export const tokenDataSchema = z
    .object({
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role":
            z.string(),
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier":
            z.string(),
    })
    .transform((data) => {
        return {
            role: data[
                "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
            ],
            username:
                data[
                    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
                ],
        };
    });
export type TokenData = z.output<typeof tokenDataSchema>;
